module.exports = __webpack_public_path__ + "static/media/img_life.6301450a.png";